import React from 'react';
import Button from '../primitives/Button';

export type InitiativeFourSectionProps = {
  className?: string;
};

const InitiativeFourSection: React.FC<InitiativeFourSectionProps> = ({
  className = '',
}) => {
  return (
    <div className={`bg-black w-full ${className}`}>
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Content Section */}
          <div className="space-y-6">
            <div className="space-y-2">
              <p className="text-sm font-semibold text-teal-400 uppercase tracking-wide">Initiative Four</p>
              <h2 className="text-3xl md:text-4xl font-bold text-white">AI Ecosystem</h2>
              <p className="text-lg font-semibold text-gray-50 leading-relaxed py-2">
                Explore our comprehensive AI ecosystem and discover the tools, platforms, and resources available across the organization.
              </p>
              <p className="text-md text-gray-50 leading-relaxed">
                From enterprise AI tools to specialized platforms, our ecosystem provides everything you need to accelerate your AI journey and drive innovation across your projects.
              </p>
            </div>
            <div className="flex gap-4">
              <a href="/initiatives/ecosystem">
                <Button variant="primary" size="md">
                  Explore Ecosystem
                </Button>
              </a>
            </div>
          </div>
          {/* Image Section */}
          <div className="w-full">
            <div className="aspect-video bg-black rounded-lg overflow-hidden">
              <img 
                src="/logos/Ecosystem.svg" 
                alt="AI Ecosystem Overview" 
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InitiativeFourSection; 